/* tslint:disable */

/**
 */
export class Compenth {
    ID_COMPENTH?: number;
    ID_COMP?: number;
    COMPTEMP?: number;
    COMPENTH?: number;
    COMPCOND?: number;
    COMPDENS?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/compenth.ts